import React, { useEffect, useState,useContext } from "react";
import SearchBox from "../../customer/components/SearchBox";
import { AuthContext } from '../../shared/context/auth-context';
import Scroll from "../../shared/components/navigation/Scroll";
import Table from "../../shared/components/Table/Table";
import ErrorModal from "../../shared/components/UIElements/ErrorModal";
import FloatingButton from "../../shared/components/UIElements/FloatingButton";
import LoadingSpinner from "../../shared/components/UIElements/LoadingSpinner";
import { useHttpClient } from "../../shared/hooks/http-hook";
import { SpecialOrderTableHeaders } from "../components/SpecialOrderTableHeaders";
import { formatPhoneNumber } from "../../print/page/Print";
import "./SpecialOrders.css"
import { useWindow } from "../../shared/hooks/window-hook";
export const dateHandler = (date) => {
  let dateArray = date.split('-');
  let day = dateArray[2].substring(0,2) ;
  let month = dateArray[1];
  let year = dateArray[0];
return `${month}/${day}/${year}`;
}

const SpecialOrders = () => {
  const { width } = useWindow();
  const auth = useContext(AuthContext);
  const [loadedSpecialOrders, setLoadedSpecialOrders] = useState([]);
  const [LoadArchive, setLoadArchive] = useState(false);
  const [searchfield, setSearchfield] = useState("");
  const { isLoading, error, sendRequest, clearError } = useHttpClient();

useEffect(() => {
  const fetchSpecialOrders = async () =>{
    let responseData;
    try {
      responseData = await sendRequest(process.env.REACT_APP_BACKEND_URL+"/specialOrders",
      "GET",
      null,
      {Authorization: 'Bearer '+ auth.token});
      
      setLoadedSpecialOrders(responseData.specialOrders);
      
    } catch (err) { }
  };
  fetchSpecialOrders();
}, [sendRequest, auth.token]);

const filteredSpecialOrders = loadedSpecialOrders.map( specialOrder => {
  return ({
    ...specialOrder,
    style: specialOrder.style.split("_")[0],
    name: specialOrder.customer.flat()[0] ? specialOrder.customer.flat()[0].name : "",
    lastname: specialOrder.customer.flat()[0] ? specialOrder.customer.flat()[0].lastname  : "" ,
    rowPhone: specialOrder.customer.flat()[0] ? specialOrder.customer.flat()[0].phone : "",
    phone: specialOrder.customer.flat()[0] ? formatPhoneNumber(specialOrder.customer.flat()[0].phone) : "",
    cid: specialOrder.customer.flat()[0] ?   specialOrder.customer.flat()[0].id  : "",
    startDate: dateHandler(specialOrder.startDate),
    eventDate: specialOrder.eventDate ? dateHandler(specialOrder.eventDate) : "",
    arrivalDate: specialOrder.arrivalDate ? dateHandler(specialOrder.arrivalDate): "",
    paymentStatus: specialOrder.paymentStatus === "on" ? '✓' : "",
    archive: specialOrder.archive === false ? 'false' : 'true' 
  })
}).filter((specialOrder) => {
    return (
      specialOrder.orderNumber.toLowerCase().includes(searchfield.toLowerCase())  ||
      specialOrder.style.toLowerCase().includes(searchfield.toLowerCase())  ||
      specialOrder.company.toLowerCase().includes(searchfield.toLowerCase())  ||
      specialOrder.color.toLowerCase().includes(searchfield.toLowerCase())  ||
      specialOrder.USSize.toLowerCase().includes(searchfield.toLowerCase())  ||
      String(specialOrder.cost).includes(searchfield)||
      String(specialOrder.price).includes(searchfield)||
      specialOrder.name.toLowerCase().includes(searchfield.toLowerCase())  ||
      specialOrder.lastname.toLowerCase().includes(searchfield.toLowerCase()) ||
      String(specialOrder.rowPhone).includes(searchfield) ||
      specialOrder.startDate.includes(searchfield.toLowerCase())   ||  
      specialOrder.eventDate.includes(searchfield.toLowerCase())  ||
      specialOrder.arrivalDate.includes(searchfield.toLowerCase()) ||
      specialOrder.location.includes(searchfield.toLowerCase())
      )
    }).filter((specialOrder ) => {
      return(
        LoadArchive === 'true' ? specialOrder.archive === 'true' : specialOrder.archive === 'false'
      );       
    }).reverse()
    

const onSearchChange = (event) => {
  setSearchfield(event.target.value);
};

const onChangeHandler = event => {
  setLoadArchive(event.target.value)
}

  return (
  <React.Fragment>
    <ErrorModal error={error} onClear={clearError} />
    {isLoading && (
      <div className="center">
        <LoadingSpinner />
      </div>
    )}
    <div className="show-order">
      <label>
      
      <select  onChange={onChangeHandler} className="pa2 bg-light-gray br3">
        <option value= {'false'} >Special Orders</option>
        <option value= {'true'} >Archived Special Orders</option>
      </select>
      </label>
    </div>
    <div className="tc"> 
      <div style={{ display: "inline-block" }}>
        <SearchBox searchChange={onSearchChange} />
      </div>
    </div>

    <Scroll>
      {!isLoading && filteredSpecialOrders && (
        <Table headers={SpecialOrderTableHeaders} content={filteredSpecialOrders} />
       )} 
    </Scroll>
    {width > 800 ? <FloatingButton route={"/specialOrders/new"} /> : ""}
  </React.Fragment>
);
};

export default SpecialOrders;